module.exports = __webpack_public_path__ + "img/Temperus_island_treasure.b537e316.png";